import { render, staticRenderFns } from "./InputNumberNew.vue?vue&type=template&id=070c277a&scoped=true&"
import script from "./InputNumberNew.vue?vue&type=script&lang=js&"
export * from "./InputNumberNew.vue?vue&type=script&lang=js&"
import style0 from "./InputNumberNew.vue?vue&type=style&index=0&id=070c277a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c277a",
  null
  
)

export default component.exports